import React from 'react';
import {PropTypes} from 'prop-types';
import HelpButton from '../HelpButton/HelpButton.react';
import './Commands.less';
import {CLOSE__24} from '@homeaway/svg-defs';
import {ButtonIcon} from '@homeaway/react-buttons';

class Commands extends React.Component {
    static propTypes = {
        onClickHelp: PropTypes.func.isRequired,
        onExit: PropTypes.func.isRequired,
        disableHelp: PropTypes.bool,
        left: PropTypes.bool,
        size: PropTypes.oneOf(['xs', 'sm', 'lg', 'xl']),
    };

    _onExitClick = () => {
        this.props.onExit();
    };

    render() {
        return (
            <div className={`Commands ${this.props.left ? 'reverse' : ''}`}>
                <ButtonIcon
                    className="ExitButton"
                    label="Default Button"
                    svgMarkup={CLOSE__24}
                    circle
                    size={this.props.size}
                    onClick={this._onExitClick}
                />
                <HelpButton
                    onClick={this.props.onClickHelp}
                    disabled={this.props.disableHelp}
                    size={this.props.size}
                />
            </div>
        );
    }
}

export default Commands;
